<template>
  <v-expand-transition>
    <v-system-bar
      v-if="!isOnline && !dismissed"
      dark
      color="error"
      app
      class="d-flex align-center justify-space-between px-3"
      style="min-height: 40px"
    >
      <div
        class="d-flex align-center flex-grow-1 justify-center text-truncate"
        style="white-space: nowrap"
      >
        <v-icon class="mr-2" size="18">mdi-minus-circle</v-icon>
        <span class="text-body-2">No Internet. Please reconnect again.</span>
      </div>
      <v-btn small icon @click="dismiss" class="ml-2">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
  </v-expand-transition>
</template>

<script>
export default {
  data() {
    return {
      isOnline: process.client ? navigator.onLine : true,
      dismissed: false
    }
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
  methods: {
    updateOnlineStatus() {
      this.isOnline = navigator.onLine
      if (!this.isOnline) {
        this.dismissed = false // Show again if offline
      }
    },
    dismiss() {
      this.dismissed = true
    }
  }
}
</script>

<style scoped>
/* Ensure text doesn't break on smaller screens */
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>